import React, { useMemo, useCallback } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IProps {
	onChange: (value: string) => void;
}

export const ApiKey: React.FC<IProps> = React.memo(({ onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCredentialApiKey') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			onChange(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="ApiKey"
			name="apiKey"
			label="credentialApiKeyLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
